// Phase — Reports Dashboard. Sales-by-category donut.
import * as React from "react";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

export interface CategorySlice {
  category: string;
  amount: number;
}

// Palette pulled from the theme's chart tokens where available, falling back to
// a fixed hue ladder so slices stay distinguishable regardless of category count.
const COLORS = [
  "hsl(var(--primary))",
  "hsl(221 83% 63%)",
  "hsl(142 71% 45%)",
  "hsl(38 92% 50%)",
  "hsl(280 65% 60%)",
  "hsl(0 72% 60%)",
  "hsl(199 89% 48%)",
];

export interface CategoryDonutChartProps {
  data: CategorySlice[];
  valueFormatter?: (v: number) => string;
}

export function CategoryDonutChart({ data, valueFormatter }: CategoryDonutChartProps) {
  const fmt = valueFormatter ?? ((v: number) => String(v));
  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie
          data={data}
          dataKey="amount"
          nameKey="category"
          innerRadius="55%"
          outerRadius="80%"
          paddingAngle={2}
        >
          {data.map((_, i) => (
            <Cell key={i} fill={COLORS[i % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip
          formatter={(v: number) => fmt(v)}
          contentStyle={{ background: "hsl(var(--popover))", border: "1px solid hsl(var(--border))", borderRadius: 8, fontSize: 12 }}
        />
        <Legend wrapperStyle={{ fontSize: 12 }} />
      </PieChart>
    </ResponsiveContainer>
  );
}

export default CategoryDonutChart;
